import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { psgraph } from 'latex2js-pstricks';
import * as d3 from 'd3';
import React, { useRef, useEffect } from 'react';
import Slider from './slider';
export default (function (props) {
  var svgRef = useRef();
  var divRef = useRef();
  var size = psgraph.getSize.call(props);
  var width = "".concat(size.width, "px");
  var height = "".concat(size.height, "px");
  useEffect(function () {
    var d3svg = d3.select(svgRef.current);

    var obj = _objectSpread({}, props);

    obj.$el = divRef.current;
    psgraph.pspicture.call(obj, d3svg);
  }, [props]);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: "pspicture",
      style: {
        width: width,
        height: height
      },
      ref: divRef
    },
    /*#__PURE__*/
    React.createElement("svg", {
      width: size.width,
      height: size.height,
      ref: svgRef
    }), props.env.sliders && props.env.sliders.map(function (slider) {
      return (
        /*#__PURE__*/
        React.createElement(Slider, {
          slider: slider,
          env: props.env,
          svgRef: svgRef,
          plot: props.plot
        })
      );
    }))
  );
});